document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const banner = document.querySelector('.tco-gdpr-banner');
  const close = document.querySelector('.tco-gdpr-close');
  const name = 'gdpr-last-visit';

  const setCookie = (name, value, days) => {
    let expires = '';

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
  }

  const gdprCookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));


  if( gdprCookie ) {
    const cookieVal = gdprCookie.split('=')[1];
    const cookieExp = parseInt(cookieVal) + 31556926;

    if( cookieExp < Date.now() / 1000 ) {
      // has cookie, is expired
      banner.classList.add('tco-gdpr-banner--visible');
      body.classList.add('tco-gdpr-present');
    }
  } else {
    // no cookie, show banner
    banner.classList.add('tco-gdpr-banner--visible');
    body.classList.add('tco-gdpr-present');
  }

  close.addEventListener('click', function() {
    banner.classList.remove('tco-gdpr-banner--visible');
    body.classList.remove('tco-gdpr-present');
    setCookie( name, Date.now() / 1000, 365 );
  })

})
